export const assetUrls = {
  hero: "https://static.prod-images.emergentagent.com/jobs/6fbbf202-a146-4e5c-a3e6-cb6a33b0793b/images/1503025439ddd732b472c30ff425410b1ee55f73fcb8fd208350c8f6b3aa315f.png",
  farmers: "/images/tatva-real/peach_group_harvest.webp",
  smilingFarmerApples: "/images/tatva-real/smiling_farmer_apples.webp",
  naturalFarming: "/images/tatva-real/sprout_hands.webp",
  hillside: "/images/tatva-real/serene_hillside.webp",
  founderHarvest: "/images/tatva-real/founder_garlic_onion.webp",
  onion: "https://static.prod-images.emergentagent.com/jobs/6fbbf202-a146-4e5c-a3e6-cb6a33b0793b/images/276a1c25c720607b298c533938e468198a98e266a921b6ff3e8033b2ae53b3fe.png",
  garlic: "/images/tatva-real/garlic_harvest.webp",
  apples: "/images/tatva-real/apple_hand.webp",
  kiwi: "https://images.unsplash.com/photo-1679065103638-7360cb935fac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kiwiSlice: "https://images.unsplash.com/photo-1650261062904-b51482026eac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  kiwiHalf: "https://images.unsplash.com/photo-1585059895524-72359e06133a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  peaches: "/images/tatva-real/peach_hill.webp",
  nectarines: "/images/tatva-real/nectarine_hand.webp",
  cinematicMistyHills: "https://static.prod-images.emergentagent.com/jobs/6fbbf202-a146-4e5c-a3e6-cb6a33b0793b/images/2aea9891dd5b7bd2c14f3cc4d2c205bb80cdf03552385e03300816719c73c378.png",
  cinematicFarmersHarvest: "https://static.prod-images.emergentagent.com/jobs/6fbbf202-a146-4e5c-a3e6-cb6a33b0793b/images/600ebf556e9dca94faf904d4ae9c2c2b5b606f635d4cc22649632927b4270f3f.png",
  cinematicPacking: "https://static.prod-images.emergentagent.com/jobs/6fbbf202-a146-4e5c-a3e6-cb6a33b0793b/images/9c51f77977ea9070a04285a06033f3e504f59fc46d69361942055579704184e0.png",
  cinematicCityHome: "https://static.prod-images.emergentagent.com/jobs/6fbbf202-a146-4e5c-a3e6-cb6a33b0793b/images/7161673460203f015c46eb474ab243615cdd1076e1cebe085b006356f375d3e3.png",
  cinematicMistTransition: "https://static.prod-images.emergentagent.com/jobs/6fbbf202-a146-4e5c-a3e6-cb6a33b0793b/images/86516ab81663c228032e1507c74d4c430eba38ab1ec70db0fa69135c6c078d3a.png",
};

export const harvestGallery = [
  { title: "Peaches carried from the orchards", image: "/images/tatva-real/peach_basket_farmer.webp" },
  { title: "Garlic harvest drying in the hills", image: "/images/tatva-real/garlic_sorting.webp" },
  { title: "Apples held by the farming community", image: "/images/tatva-real/smiling_farmer_apples.webp" },
  { title: "Seedlings cared for by hand", image: "/images/tatva-real/seedlings.webp" },
];

export const products = [
  {
    id: "prod_kiwi",
    slug: "himalayan-kiwi",
    name: "Himalayan Kiwi",
    category: "Fruits",
    availability: "Coming Soon",
    badge: "Coming Soon",
    price: 0,
    priceLabel: "",
    packSize: "Coming soon",
    minQuantity: 1,
    isAvailable: false,
    comingSoon: true,
    unavailableNote: "Coming soon. Himalayan kiwis will be available for orders shortly.",
    image: assetUrls.kiwi,
    gallery: [assetUrls.kiwi, assetUrls.kiwiSlice, assetUrls.kiwiHalf],
    shortDescription: "Tangy, emerald-green kiwis grown naturally in the Uttarakhand hills.",
    description:
      "Sweet-tart Himalayan kiwis grown in the cool hill air of Uttarakhand. Launching soon for the new season — stay tuned.",
    feature: "Tangy, juicy and vitamin-rich.",
    color: "#6E8B3D",
    storage: "Keep at room temperature to ripen, then refrigerate.",
    delivery: "Packed with care for city delivery once the season opens.",
  },
  {
    id: "prod_onion",
    slug: "natural-hill-onion",
    name: "Natural Hill Onion",
    category: "Vegetables",
    availability: "Out of Season",
    badge: "Out of Season",
    price: 149,
    priceLabel: "₹149",
    packSize: "1 kg pack",
    minQuantity: 1,
    isAvailable: false,
    unavailableNote: "Currently unavailable as this is not the harvesting season.",
    image: assetUrls.onion,
    gallery: [assetUrls.onion, "/images/tatva-real/founder_garlic_onion.webp", "/images/tatva-real/serene_hillside.webp"],
    shortDescription: "Earthy, sharp onions grown naturally in Tatva Hills soil.",
    description:
      "Raised in mountain soil by farmers across Tatva Hills, these onions bring a clean, honest sharpness to everyday cooking.",
    feature: "Earthy, sharp, naturally grown in hill soil.",
    color: "#C84B31",
    storage: "Store in a cool, dry, airy place away from direct sunlight.",
    delivery: "Packed after harvest checks and sent in sturdy farm-to-city cartons.",
  },
  {
    id: "prod_garlic",
    slug: "natural-hill-garlic",
    name: "Natural Hill Garlic",
    category: "Vegetables",
    availability: "Out of Season",
    badge: "Out of Season",
    price: 189,
    priceLabel: "₹189",
    packSize: "500 g pack",
    minQuantity: 1,
    isAvailable: false,
    unavailableNote: "Currently unavailable as this is not the harvesting season.",
    image: assetUrls.garlic,
    gallery: [assetUrls.garlic, "/images/tatva-real/garlic_farmer.webp", "/images/tatva-real/garlic_sorting.webp"],
    shortDescription: "Bold, aromatic garlic bulbs raised without synthetic pesticides.",
    description:
      "Farm-grown garlic with a full aroma and grounded hill-farm character, harvested in small seasonal batches.",
    feature: "Bold, aromatic and patiently farm-grown.",
    color: "#E8C872",
    storage: "Keep dry, ventilated and away from moisture.",
    delivery: "Delivered in breathable packaging to protect natural texture.",
  },
  {
    id: "prod_apples",
    slug: "uttarakhand-apples",
    name: "Uttarakhand Apples",
    category: "Fruits",
    availability: "Out of Season",
    badge: "Out of Season",
    price: 500,
    priceLabel: "₹500",
    packSize: "1 kg",
    minQuantity: 2,
    isAvailable: false,
    unavailableNote: "Currently unavailable as the apple harvest season is over.",
    image: assetUrls.apples,
    gallery: [assetUrls.apples, "/images/tatva-real/apple_tree.webp", "/images/tatva-real/apples_rain.webp"],
    shortDescription: "Crisp mountain apples shaped by cool air and careful harvests.",
    description:
      "Fresh Uttarakhand apples from hill orchards, selected for texture, fragrance and natural seasonal character.",
    feature: "Crisp, juicy and grown in mountain air.",
    color: "#C84B31",
    storage: "Refrigerate after delivery and consume within the week for best texture.",
    delivery: "Cushioned in a fruit-safe box for city delivery.",
  },
  {
    id: "prod_peaches",
    slug: "fresh-peaches",
    name: "Fresh Peaches",
    category: "Fruits",
    availability: "Out of Season",
    badge: "Out of Season",
    price: 349,
    priceLabel: "₹349",
    packSize: "750 g tray",
    minQuantity: 1,
    isAvailable: false,
    unavailableNote: "Currently unavailable as this is not the harvesting season.",
    image: assetUrls.peaches,
    gallery: [assetUrls.peaches, "/images/tatva-real/peach_checking.webp", "/images/tatva-real/peaches_rain.webp"],
    shortDescription: "Soft, fragrant peaches picked during their hill-season window.",
    description:
      "A delicate seasonal harvest with a warm aroma and soft bite, packed with care for city homes.",
    feature: "Soft, fragrant and seasonal.",
    color: "#E8A382",
    storage: "Ripen at room temperature, then refrigerate once soft.",
    delivery: "Handled gently and delivered in protective trays.",
  },
  {
    id: "prod_nectarines",
    slug: "fresh-nectarines",
    name: "Fresh Nectarines",
    category: "Fruits",
    availability: "Out of Season",
    badge: "Out of Season",
    price: 369,
    priceLabel: "₹369",
    packSize: "750 g tray",
    minQuantity: 1,
    isAvailable: false,
    unavailableNote: "Currently unavailable as this is not the harvesting season.",
    image: assetUrls.nectarines,
    gallery: [assetUrls.nectarines, "/images/tatva-real/nectarine_farmer_hand.webp", "/images/tatva-real/nectarine_farmer.webp"],
    shortDescription: "Smooth, sweet and vibrant fruit from the mountain season.",
    description:
      "A bright, smooth-skinned seasonal fruit grown in hill air and packed as the harvest allows.",
    feature: "Smooth, sweet and vibrant.",
    color: "#E8A382",
    storage: "Keep at room temperature until ripe, then refrigerate.",
    delivery: "Packed in small batches as seasonal availability changes.",
  },
];

products.sort((a, b) => {
  if (a.isAvailable === b.isAvailable) return 0;
  return a.isAvailable ? -1 : 1;
});

export const getProductBySlug = (slug) => products.find((product) => product.slug === slug);